export default __webpack_public_path__ + "static/media/check-mark.d0e6dfc9.svg";